import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DateAdapter } from '@angular/material';

@Injectable()
export class TranslateService {
  data: any = {};
  constructor(private http: HttpClient,private dateAdapter: DateAdapter<Date>) { }

  use(lang: string): Promise<{}> {
  
    if(lang == "vn"){ 
      this.dateAdapter.setLocale("vi-VN"); 
    }
    else{
      this.dateAdapter.setLocale("en-GB"); 

    }
    return new Promise<{}>((resolve, reject) => {
      const langPath = `assets/i18n/${lang || 'en'}.json`;
      this.http.get<{}>(langPath).subscribe(
        translation => {
          this.data = Object.assign({}, translation || {});
          resolve(this.data);
        },
        error => {
          this.data = {};
          resolve(this.data);
        }
      );
    });
  }
  langChange(lang : String){
   

  }
}
